import BaseLayer from "./BaseLayer";
import {drawLine, imagetoCanvasPosHelper} from "../utils/map_utils";
import {Stack} from "@mui/material";

class Wsi3ZDropThresh extends BaseLayer {
    id = "zDropThresh";
    label = "Z-Drop Thresh";
    defaultVisible = this.props.tileViewerState[this.id];

    onFeatureSelect = () => undefined;

    draw = () => new Promise((resolve, reject) => {
        let {slide, wsi3ZDropOutput, deviceSettings, textSize} = this.props;
        let {loc_on_machine, bucket_name, tile_viewer_path, uperpixel, tile_width, tile_height} = slide

        if (wsi3ZDropOutput !== undefined && wsi3ZDropOutput['dropsPerCellKey'] !== undefined) {
            for (const [key, value] of Object.entries(wsi3ZDropOutput['dropsPerCellKey'])) {
                const xHori = parseInt(key.split('y')[0].split('x')[1]);
                const yVerti = parseInt(key.split('y')[1]);
                let rectStartPoint = imagetoCanvasPosHelper({device_settings: deviceSettings},
                    slide, slide.x_fields - xHori, yVerti);
                let dropString = "";
                let elems = [];
                let useOrange = false;
                for (let dropInfo of value) {
                    if (dropInfo["failure"] === false) {
                        let linkToCrops = "app://" + loc_on_machine + "/scans/" + bucket_name + "/" + tile_viewer_path + dropInfo["debugPath"];
                        let dropVal = Math.round(dropInfo["fvaluePercentageChange"] * 100.0) / 100.0;
                        if (dropVal > wsi3ZDropOutput['allowedFValuePercentageChange']) {
                            useOrange = true;
                        }
                        let dropS = dropVal + "%";
                        elems.push(<a href={linkToCrops}>{"F-value % change " + dropS}</a>);
                        dropString += dropS + ", ";
                    } else {
                        elems.push(<span>{"Fail: " + dropInfo["message"]}</span>);
                        dropString += "F, ";
                        useOrange = true;
                    }
                }

                let popupText = (
                    <Stack>
                        {elems}
                    </Stack>
                );
                let orangeColor = "#ff8c00";
                let greenColor = "#39FF14";
                let textColor = useOrange ? orangeColor : greenColor;
                drawLine(rectStartPoint.x + 0.1 * tile_width * uperpixel,
                    rectStartPoint.y - 0.1 * tile_height * uperpixel,
                    1, this.layer.getSource(), dropString, 10,
                    "#E9D6C5", popupText, textColor, textSize);
            }
        }
        resolve();
    });
}

export default Wsi3ZDropThresh;